export class RegisterType {
    static get INDIVIDUAL() {
        return 'individual';
    }
}